module.exports = __webpack_public_path__ + "static/fonts/iconfont.ca814d57.woff";